import * as React from "react";
import { Typography, CircularProgress, Box } from "@mui/material/";
import InnerPage from "../components/InnerPage";
import Users from "../components/SuperAdminUsers";

export default function UsersScreen({ user }) {
  const [loading, setLoading] = React.useState(true);

  // Use timeout to simulate loading state
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <InnerPage title="Global User View">
      {loading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
            gap: 3,
            minHeight: 400,
          }}
        >
          <CircularProgress size={60} />
          <Typography variant="h6" color="text.primary">
            Loading Super Admin Users...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Fetching data from the server...
          </Typography>
        </Box>
      ) : (
        <Users user={user} />
      )}
    </InnerPage>
  );
}
